module.exports = __webpack_public_path__ + "static/img/per1.87f63b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per1.jpg
// module id = 1eZw
// module chunks = 41